// Today's loadings grouped by what the planner has to do with them (#117).
// Order = attention first; inside a section by planned time. Empty sections are left out.
export const SECTIONS = [
  { key: 'action', states: ['no-info', 'not-coming'] },
  { key: 'onSite', states: ['on-site'] },
  { key: 'enRoute', states: ['en-route'] },
  { key: 'confirmed', states: ['confirmed'] },
  { key: 'later', states: ['rescheduled', 'no-power'] },
  { key: 'loaded', states: ['loaded'], collapsed: true },
];

export function loadingSections(loadings) {
  return SECTIONS
    .map(s => ({
      ...s,
      items: loadings
        .filter(l => s.states.includes(l.state))
        .sort((a, b) => a.plannedAt.localeCompare(b.plannedAt)),
    }))
    .filter(s => s.items.length > 0);
}
